// スポットバイトを探す

import { hasClass } from "hiraku/lib/lib";


//-スポットバイトを探す　サイドバー閉じる開ける-
// $('#result-btn').on('click', function () {
// 	$('.result-wrap').toggleClass('close2');
// 	$('.btn2').toggleClass('close2');
// });
$('#search-btn').on('click', function () {
	$('.side-menu').toggleClass('close3');
	$('.btn1').toggleClass('close3');
	if ($('.btn1').hasClass('close3')) {
		$('.sm-btn').text('絞り込む');
	} else {
		$('.sm-btn').text('閉じる　');
	}
});


//検索結果がないときは非表示
// if ($('.result').length) {
// 	$('.search-page .btn-box2 .toggle-btn.btn2').css('display', 'block');
// };



//スマホ時の処理
$(function () {
	if (window.matchMedia('(max-width: 768px)').matches) {
		// 検索ボックスを隠す
		$('.side-menu').addClass('close3');
		$('.btn1').addClass('close3');
		// ボタンを100％
		$('.search-page .btn-box2 #search-btn').css('width', '100%');
		$('#current-location-button').on('click', function () {
			$('.side-menu').addClass('close3');
			$('.btn1').addClass('close3');
			$('.sm-btn').text('絞り込む');
		 });

		 //絞り込む(検索)を押すと閉じる
		$('#search-button').on('click', function () {
			$('.side-menu').addClass('close3');
			$('.sm-btn').text('絞り込む');
			$('.btn1').addClass('close3');
		}); 

		//サイドバー検索結果がある場合ボタンを半分ずつにする不必要
		// if ($('.result').length) {
		// 	$('.search-page .btn-box2 #search-btn').css('width', '50%');
		// 	$('.search-page .btn-box2 #result-btn').css('width', '50%');
		// }else{
		// 	$('.search-page .btn-box2 .toggle-btn').css('width', 'auto');
		// };
		//どっちか開いてたら閉じる
		// $('#result-btn').on('click', function () {
		// 	$('.side-menu').addClass('close3');
		// });
		// $('#search-btn').on('click', function () {
		// 	$('.result').addClass('close2');
		// });
		//最初リザルトは閉じておく
		// if ($('.result-wrap').hasClass('close2')) {
		// }else{
		// 	$('.result-wrap').addClass('close2');
		// 	};

	} else {
		$('.search-page .btn-box2 .toggle-btn').css('width', 'auto');
	};

});

// //吹き出しの中身
// $(function () {
//     if (! document.getElementById("map")) {
//         return;
//     }
//
// 	var myMap = new google.maps.Map(document.getElementById("map"), {
// 		zoom: 16,
// 		center: new google.maps.LatLng(35.630792, 139.737877),
// 		mapTypeId: google.maps.MapTypeId.ROADMAP,
// 		scrollwheel: false
// 	});
// 	var myMarker = new google.maps.Marker({
// 		// マーカーを置く緯度経度
// 		position: new google.maps.LatLng(35.630792, 139.737877),
// 		map: myMap
// 	});
// 	var myInfoWindow = new google.maps.InfoWindow({
// 		content:
// 		 `
// 		<div class="result-map">
// 			<div class="wrap">
//                 <img src="/img/home/byte-1.png" alt="店舗イメージ画像">
//                 <span class="registered">美容所検査書確認済み</span>
// 				<span class="registered">管理美容師確認済み</span>
// 				<p><i class="fa-solid fa-store"></i>美容室名:<br><span>田舎でサロン</span></p>
// 				 <p><i class="fa-solid fa-circle-user"></i>求める人材:<br><span>シャンプーができる人</span></p>
// 				 <p><i class="fa-solid fa-yen-sign"></i>給与･報酬:<br><span>1500円～</span></p>
// 				 <p><i class="fa-solid fa-calendar-days"></i>募集日:<br><span>2022/10/05</span></p>
// 				  <div class="btn-wrap">
//                     <a class="btn btn-primary" href="/">詳細</a>
//                   </div>
//         	</div>
// 		</div>`
// 	});
// 	// 吹き出しを開く
// 	myInfoWindow.open(myMap, myMarker);
// 	// 吹き出しが閉じられたら、マーカークリックで再び開くようにしておく
// 	google.maps.event.addListener(myInfoWindow, "closeclick", function () {
// 		google.maps.event.addListenerOnce(myMarker, "click", function (event) {
// 			myInfoWindow.open(myMap, myMarker);
// 		});
// 	});
// });


